import { Box as e } from "./Box.mjs";
import { Flex as t } from "./Flex.mjs";
import { Skeleton as n } from "./Skeleton.mjs";
import { Grid as r } from "./Grid.mjs";
import { useEffect as i, useMemo as a, useRef as o, useState as s } from "react";
import { useTranslation as c } from "@maat/store-i18n";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
import { useVirtualizer as f, useWindowVirtualizer as p } from "@tanstack/react-virtual";
//#region src/components/Primitives/VirtualGrid.tsx
var m = ({ data: m, renderItem: h, columns: g = 3, estimateSize: _ = 380, isLoading: v = !1, isFetchingNextPage: y = !1, onEndReached: b, scrollRef: x, customScrollElement: S, scrollTarget: C, emptyMessage: w, gap: T = 4, renderSkeleton: E, skeletonRows: D = 3 }) => {
	let { t: O } = c("ds"), k = C === "window", A = C && C !== "window" ? C : S, [j, M] = s(() => {
		if (typeof g == "number") return g;
		if (typeof window > "u") return g.base ?? 1;
		let e = window.innerWidth;
		return e >= 1280 && g.xl != null ? g.xl : e >= 1024 && g.lg != null ? g.lg : e >= 768 && g.md != null ? g.md : e >= 640 && g.sm != null ? g.sm : g.base ?? 1;
	});
	i(() => {
		if (typeof g == "number") return;
		let e = () => {
			let e = window.innerWidth, t = g.base ?? 1;
			e >= 640 && g.sm != null && (t = g.sm), e >= 768 && g.md != null && (t = g.md), e >= 1024 && g.lg != null && (t = g.lg), e >= 1280 && g.xl != null && (t = g.xl), M((e) => e === t ? e : t);
		};
		return window.addEventListener("resize", e, { passive: !0 }), () => window.removeEventListener("resize", e);
	}, [g]);
	let N = a(() => {
		let e = [];
		for (let t = 0; t < m.length; t += j) e.push(m.slice(t, t + j));
		return e;
	}, [m, j]), P = o(null), F = o(null), I = o(null), L = p({
		count: N.length,
		estimateSize: () => _ + T * 8,
		overscan: 2
	}), R = f({
		count: N.length,
		getScrollElement: () => A ?? x?.current ?? null,
		estimateSize: () => _ + T * 8,
		overscan: 2
	}), z = (A || x?.current) && !k ? R : L, B = z.getVirtualItems();
	return i(() => {
		if (!b) return;
		let e = k ? null : A || x?.current || null;
		return F.current = new IntersectionObserver((e) => {
			e[0].isIntersecting && !y && !v && b();
		}, {
			root: e,
			rootMargin: "0px 0px 200px 0px",
			threshold: .1
		}), I.current && F.current.observe(I.current), () => F.current?.disconnect();
	}, [
		b,
		y,
		v,
		x,
		A,
		k
	]), !v && m.length === 0 ? /* @__PURE__ */ u(e, {
		p: 4,
		style: {
			textAlign: "center",
			color: "gray"
		},
		children: w ?? O("ds:grid.empty")
	}) : v && m.length === 0 ? /* @__PURE__ */ u(r, {
		columns: j,
		gap: T,
		children: Array.from({ length: j * D }, (t, r) => E ? /* @__PURE__ */ u(e, { children: E(r) }, r) : /* @__PURE__ */ u(n, {
			height: _,
			width: "100%",
			radius: "md"
		}, r))
	}) : /* @__PURE__ */ d(l, { children: [/* @__PURE__ */ d(e, {
		ref: P,
		position: "relative",
		w: "100%",
		h: `${z.getTotalSize()}px`,
		style: { overflowX: "hidden" },
		children: [B.map((t) => {
			let n = N[t.index];
			return /* @__PURE__ */ u(e, {
				"data-index": t.index,
				ref: z.measureElement,
				position: "absolute",
				top: 0,
				left: 0,
				w: "100%",
				style: { transform: `translateY(${t.start}px)` },
				pb: T,
				children: /* @__PURE__ */ u(r, {
					columns: j,
					gap: T,
					style: {
						alignItems: "flex-start",
						minWidth: 0
					},
					children: n.map((n, r) => {
						let i = t.index * j + r;
						return /* @__PURE__ */ u(e, {
							style: {
								overflow: "hidden",
								minWidth: 0
							},
							children: h(n, i)
						}, i);
					})
				})
			}, t.index);
		}), b && m.length > 0 && /* @__PURE__ */ u(e, {
			ref: I,
			position: "absolute",
			bottom: "0",
			left: "0",
			w: "100%",
			h: "1px",
			opacity: 0,
			style: { pointerEvents: "none" }
		})]
	}), y && m.length > 0 && /* @__PURE__ */ u(e, {
		pt: T,
		w: "100%",
		children: E ? /* @__PURE__ */ u(r, {
			columns: j,
			gap: T,
			style: {
				alignItems: "flex-start",
				minWidth: 0
			},
			children: Array.from({ length: j }, (t, n) => /* @__PURE__ */ u(e, { children: E(n) }, n))
		}) : /* @__PURE__ */ u(t, {
			w: "100%",
			justify: "center",
			py: 4,
			children: /* @__PURE__ */ u(n, {
				height: 20,
				width: 150
			})
		})
	})] });
};
//#endregion
export { m as VirtualGrid };
